import { render, staticRenderFns } from "./ModalProductLabel.vue?vue&type=template&id=f80704b2&scoped=true&"
import script from "./ModalProductLabel.vue?vue&type=script&lang=js&"
export * from "./ModalProductLabel.vue?vue&type=script&lang=js&"
import style0 from "./ModalProductLabel.vue?vue&type=style&index=0&id=f80704b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80704b2",
  null
  
)

export default component.exports